var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "bd5bb647f628494f7a4153dc1b7d5a4d36bc0a2d"
};